import angular from 'angular';
import TimezoneFactory from './timezone-list.factory'

let TimezoneModule = angular.module('app.timezone-list', [])

    .factory('TimezoneList', TimezoneFactory)

    .name;

export default TimezoneModule;


// WEBPACK FOOTER //
// ./client/app/common/timezone-list/index.js